import React, { useState } from 'react';
import { useLocation, Router } from 'react-router-dom';
import SideBarContainer from 'Containers/SideBarContainer';
import SelectTable from '../../Components/SelectTable';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import style from './style';
import useDepartments from './Hooks/useDepartment';
import useComponent from './Hooks/useComponent';
import useSearch from './Hooks/useSearch';
import useTranslation from '../../Hooks/useTranslation';
import useRoute from './Hooks/useRoute';

const { containerEmployee, searchContainer, findContainer } = style;

export default function Departments() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  if (location?.state?.isComingFrom !== '/definicion') {
    return <Router to="/definicion" />;
  }
  const { t } = useTranslation();
  const { t2 } = useTranslation('Department');
  const { departments, setDepartments } = useDepartments(setIsLoading);
  const { thereIsComponent } = useComponent({ departments, setDepartments });
  const { setSearch, setStatus, departmentsFilters } = useSearch({
    departments,
  });
  const { handlePage } = useRoute();
  const methods = [setStatus];
  const titles = [t2('Status')];
  const options = [['Activo', 'Inactivo']];

  return (
    <SideBarContainer>
      <div style={containerEmployee}>
        <Title title={t2('Title')} subtitle="" />
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search placeholder={t2('Title')} setData={setSearch} />
          </div>
        </div>

        <SelectTable
          headers={[t2('Name'), t('Generic.NumberOfEmployees'), t('Generic.NumberOfCourses')]}
          information={departmentsFilters}
          thereIsComponent={thereIsComponent}
          limit={3}
          checkbox={false}
          event={handlePage}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
